export default __webpack_public_path__ + "static/media/aircare-poster-2.2223681e.jpg";